export const logos =  {
      'Djak Sport': 'assets/djaklogo1_mini.svg',
      'Planeta Sport': 'assets/logo_planeta_mini.svg',
      'N Sport': 'assets/logo_nsport_web_mini.svg',
      'Sport Vision': 'assets/sport_vision_logo_mini.png',
      Buzz: 'assets/buzz_logo.png',
      Tike: 'assets/tike.jpg',
      'The Spot': 'assets/theSpotLogo.png'
    };
